import { ProcedureType } from "../enums/procedure-type.enum";

export const ProcedureTypePrefixDict: Record<ProcedureType,number> = {
    [ProcedureType.Automation]: 1,
    [ProcedureType.Maintenance]: 2,
    [ProcedureType.Metals]: 3,
    [ProcedureType.Plastics]: 4,
}

